import './ThreeDotsLoader.scss';

export const ThreeDotsLoader = (): JSX.Element => (
  <div className="dot-flashing" />
);
